// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGZoom2IconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGZoom2Icon extends PureComponent<
  ISVGZoom2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="45px"
        height="45px"
        viewBox="0 0 35 35"
      >
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M14.387,2.581c-6.417,0-11.623,5.202-11.623,11.623
		c0,6.419,5.205,11.623,11.623,11.623c6.419,0,11.625-5.203,11.625-11.623C26.012,7.783,20.807,2.581,14.387,2.581z M14.387,24.225
		c-5.536,0-10.022-4.486-10.022-10.021c0-5.536,4.489-10.023,10.022-10.023c5.537,0,10.023,4.487,10.023,10.023
		C24.41,19.738,19.924,24.225,14.387,24.225z"
        />
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M34.34,29.959c-1.107-1.135-4.869-5.486-7.332-7.406l-1.088-1.07
		c-0.289-0.281-0.844-0.184-1.238,0.217l-2.393,2.434c-0.396,0.402-0.484,0.959-0.197,1.242l2.096,2.059
		c0.045,0.047,0.1,0.08,0.16,0.105c1.516,1.896,4.555,5.314,6.322,5.914c0.725,0.512,2.16,0.201,2.68-0.242
		C34.533,32.4,34.609,30.725,34.34,29.959z"
        />
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M12.154,1.283c-6.417,0-11.623,5.202-11.623,11.623
		c0,6.419,5.205,11.622,11.623,11.622c6.42,0,11.625-5.203,11.625-11.622C23.779,6.485,18.574,1.283,12.154,1.283z M12.154,22.928
		c-5.536,0-10.022-4.488-10.022-10.022c0-5.536,4.489-10.023,10.022-10.023c5.535,0,10.021,4.487,10.021,10.023
		C22.176,18.439,17.689,22.928,12.154,22.928z"
        />
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M32.199,29.959c-1.105-1.135-4.869-5.486-7.33-7.406l-1.088-1.07
		c-0.289-0.281-0.844-0.184-1.238,0.217l-2.395,2.434c-0.395,0.402-0.484,0.959-0.197,1.242l2.096,2.059
		c0.045,0.047,0.102,0.08,0.16,0.105c1.516,1.896,4.555,5.314,6.322,5.914c0.727,0.512,2.162,0.201,2.682-0.242
		C32.395,32.4,32.471,30.725,32.199,29.959z"
        />
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M10.993,8.096c0,0.144,0.273,0.359,0.273,0.503c-3.269,1.543-4.692,6.095-2.041,8.979
		c0.908,0.986,1.66,1.384,2.914,2.371c0.094,0.523-0.253,0.389-0.562,0.293c-0.197,0-1.327-0.475-2.062-0.941
		c-2.546-1.612-3.877-5.88-2.042-8.833c0.459-0.741,1.383-1.305,2.122-1.912C9.78,8.404,10.549,7.977,10.993,8.096z"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="23.781"
          y1="21.482"
          x2="25.375"
          y2="21.482"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="32.199"
          y1="29.959"
          x2="33.795"
          y2="29.959"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="23.045"
          y1="9.892"
          x2="24.734"
          y2="10.218"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="23.211"
          y1="16.344"
          x2="24.734"
          y2="16.614"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="20.328"
          y1="21.482"
          x2="21.922"
          y2="21.482"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="19.783"
          y1="4.822"
          x2="21.922"
          y2="5.349"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="1.973"
          y1="12.702"
          x2="3.557"
          y2="12.905"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="3.557"
          y1="18.867"
          x2="5.233"
          y2="18.994"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="5.233"
          y1="5.991"
          x2="6.764"
          y2="6.062"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="8.299"
          y1="22.742"
          x2="9.388"
          y2="22.523"
        />
      </svg>
    );
  }
}
